import toast from "react-hot-toast";
import { Box, Typography, IconButton, Paper } from "@mui/material";
import { Close, CheckCircle, Info, Warning, Error } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const StyledToast = styled(Paper)(({ theme }) => ({
  background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
  color: "#0f2b46",
  padding: "16px 20px",
  borderRadius: "16px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minWidth: "320px",
  maxWidth: "420px",
  boxShadow: "var(--shadow-lg)",
  border: "1px solid #e2e8f0",
  backdropFilter: "blur(8px)",
  animation: "slideInLight 0.4s ease-out",
  "@keyframes slideInLight": {
    "0%": {
      transform: "translateX(100%)",
      opacity: 0,
    },
    "100%": {
      transform: "translateX(0)",
      opacity: 1,
    },
  },
  "&:hover": {
    transform: "translateY(-1px)",
    boxShadow: "var(--shadow-xl)",
    transition: "all 0.1s ease",
  },
}));

const MessageContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "14px",
  flex: 1,
});

const sendToast = (message, type = "info") => {
  // For error type, generate unique ID to ensure it always shows
  const toastId = type === "error" 
    ? `toast-error-${Date.now()}-${Math.random()}`
    : `toast-${message}-${type}`;
  
  // For non-error types, check if already active
  if (type !== "error" && toast.isActive(`toast-${message}-${type}`)) {
    return;
  }

  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckCircle sx={{ color: "#66D59A", fontSize: 22 }} />;
      case "error":
        return <Error sx={{ color: "#FF6B6B", fontSize: 22 }} />;
      case "warning":
        return <Warning sx={{ color: "var(--amber)", fontSize: 22 }} />;
      default:
        return <Info sx={{ color: "#0f2b46", fontSize: 22 }} />;
    }
  };

  toast.custom(
    (t) => (
      <StyledToast
        elevation={0}
        onClick={() => toast.dismiss(t.id)}
        sx={{ cursor: "pointer" }}
      >
        <MessageContainer>
          {getIcon()}
          <Typography
            variant="body1"
            sx={{
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: 1.5,
              color: "#0f2b46",
              letterSpacing: "0.2px",
            }}
          >
            {message}
          </Typography>
        </MessageContainer>
        
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            toast.dismiss(t.id);
          }}
          sx={{
            color: "#94a3b8",
            "&:hover": {
              color: "#0f2b46",
              backgroundColor: "rgba(6, 49, 100, 0.05)",
            },
          }}
        >
          <Close fontSize="small" />
        </IconButton>
      </StyledToast>
    ),
    {
      id: toastId,
      duration: 4000,
      position: "top-center",
    }
  );
};

export default sendToast;

